import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { theme } from 'theme';

interface AdvicePopperProps {
  accordions: { details: string; summary: string }[];
  title: string;
}
export const AdvicePopper: FC<AdvicePopperProps> = ({ accordions, title }) => {
  return (
    <Box>
      <Box
        sx={{
          borderBottom: `solid 1px ${theme.palette.grey[300]}`,
          mt: -2.5,
          mr: -3,
          ml: -2,
          pt: 1.8,
          px: 2,
          pb: 1.25,
        }}
      >
        <Typography sx={{ fontWeight: 500 }}>{title}</Typography>
      </Box>

      <Box sx={{ mt: 1, mr: -1, mb: -1 }}>
        {accordions.map((accordion, i) => (
          <Accordion
            sx={{
              border: 0,
              boxShadow: 'none',
              '&::before': {
                backgroundColor: theme.palette.grey[200],
              },
            }}
            key={accordion.summary}
          >
            <AccordionSummary sx={{ px: 0 }} expandIcon={<ExpandMoreIcon />}>
              <Badge
                badgeContent={i + 1}
                sx={{
                  alignItems: 'center',
                  backgroundColor: theme.palette.grey[400],
                  color: 'white',
                  position: 'relative',
                  top: '4px',
                  transform: 'none',
                  zoom: 0.75,
                }}
              />
              <Typography variant="subtitle2" sx={{ pl: 1 }}>
                {accordion.summary}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0 }}>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                {accordion.details}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};
